// extracted by mini-css-extract-plugin
export default {"root":"DeactivationInfoModal_root__TSk7y","item":"DeactivationInfoModal_item__L3cgX","separator":"DeactivationInfoModal_separator__-j7F7"};